"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.PostMailCustomLetterSocketEvent = void 0;
var PostMailCustomLetterSocketEvent;
(function (PostMailCustomLetterSocketEvent) {
    PostMailCustomLetterSocketEvent["JoinRoom"] = "postMailCustomLetter:joinRoom";
    PostMailCustomLetterSocketEvent["LeaveRoom"] = "postMailCustomLetter:leaveRoom";
    PostMailCustomLetterSocketEvent["JobCompleted"] = "postMailCustomLetter:jobCompleted";
})(PostMailCustomLetterSocketEvent || (exports.PostMailCustomLetterSocketEvent = PostMailCustomLetterSocketEvent = {}));
